import React from "react";
import { ArticuloTiendaFoto, ListaArticulosTienda, } from "./TiendaArticulosStyled";
var TiendaArticulos = function (_a) {
    var articulos = _a.articulos, viewContext = _a.viewContext, relevancia = _a.relevancia;
    return (React.createElement(ListaArticulosTienda, null, articulos.map(function (articulo) { return (React.createElement(ArticuloTiendaFoto, { viewContext: viewContext, relevancia: relevancia, key: articulo.prod_urlseo },
        React.createElement("a", { href: articulo.prod_urlseo },
            React.createElement("img", { src: articulo.foto_principal, alt: articulo.titulo, title: articulo.titulo })))); })));
};
export default TiendaArticulos;
